import { Api } from "./Api";
import {
  Publication,
  CreatePublicationBody,
  EditPublicationBody,
} from "./types";

export const PublicationApi = {
  async getPublications() {
    try {
      const { data: response } = await Api.get<{ payload?: Publication[] }>(
        `/publications/get-all`
      );
      return response.payload ?? null;
    } catch (error) {
      console.log(error);
    }
  },
  async createNewPublication(publicationData: CreatePublicationBody) {
    try {
      const { data: response } = await Api.post(
        `/publications/create`,
        publicationData
      );
      return response;
    } catch (error) {
      console.error(error);
    }
  },
  async editPublication(id: number, publicationData: EditPublicationBody) {
    try {
      const { data: response } = await Api.patch(
        `/publications/${id}/update`,
        publicationData
      );
      return response;
    } catch (error) {
      console.error(error);
    }
  },
  async deletePublication(id: number) {
    try {
      const { data: response } = await Api.delete(`/publications/${id}/delete`);
      return response;
    } catch (error) {
      console.error(error);
    }
  },
};
